import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { PlActions } from '../actions';

@Injectable()
export class PlEffects {
  loadPl$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlActions.plLoadRequested),
      map(({}) =>
        PlActions.plLoaded({
          entries: [],
        })
      )
    )
  );

  addPl$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlActions.plAddRowRequested),
      map(({entry}) => PlActions.plRowAdded({ entry }))
    )
  );

  deletePl$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlActions.plDeleteRequested),
      map(({entries}) => {
          const ids = entries.map(entry => entry.key);
          return PlActions.plDeleted({ ids });
      })
    )
  );

  constructor(private actions$: Actions, private store: Store<AppState>) {}
}
